import { render } from "./EmployeeSection.vue?vue&type=template&id=83782d70&scoped=true"
import script from "./EmployeeSection.vue?vue&type=script&lang=js"
export * from "./EmployeeSection.vue?vue&type=script&lang=js"

import "./EmployeeSection.vue?vue&type=style&index=0&id=83782d70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83782d70"]])

export default __exports__